import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const CTASection = () => {
  return (
    <section className="py-24 md:py-32">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center max-w-3xl mx-auto">

          <h2 className="text-3xl sm:text-5xl font-display font-bold mb-6">
            Your Next Chapter Starts<br />
            <span className="text-gradient">With a Swipe</span>
          </h2>
          <p className="text-muted-foreground text-lg mb-10 max-w-xl mx-auto">

          </p>
          <Button asChild size="lg" className="glow-primary text-base px-10 py-6 gap-2">
            <a href="https://app.adv3nture.io" target="_blank" rel="noopener noreferrer">
              Get Early Access <ArrowRight className="w-4 h-4" />
            </a>
          </Button>
        </motion.div>
      </div>
    </section>);

};

export default CTASection;